import React from "react";
import { getUIColorPalette } from "../../../theme/ColorPalette";
import { normalizeStopLabel } from "../../../tools/StringTools";
import { getItineraryLegColorHex } from "../../../tools/TransportModeColorsTools";
import { type ItineraryLegDTO } from "../../../types/dtos/api/itinerary/itinerary.dto";
import { formatItineraryTime, getItineraryDetailsLegPillColor, hasNonEmptyText, isTransitLegMode } from "./itineraryDetails.tools";

interface ItineraryDetailsLegEndProps {
    "leg":      ItineraryLegDTO;
    "nextLeg":  ItineraryLegDTO | undefined;
    "isDarkUi": boolean;
}

const WRAPPER_CLASS_NAME = "flex items-stretch";
const CONNECTOR_PADDING_CLASS_NAME = "pl-[36px]";

interface ArrivalBadgeProps {
    "leg":      ItineraryLegDTO;
    "isDarkUi": boolean;
}

const ArrivalBadge: React.FC<ArrivalBadgeProps> = ( { leg, isDarkUi } ) => {
    const palette = getUIColorPalette( isDarkUi );

    return (
        <>
            <span
                className="mr-2 min-w-0 truncate rounded-md rounded-bl-none rounded-tl-none border-[2px] border-l-0 px-2 text-xs font-semibold"
                style={{
                    "borderColor": getItineraryDetailsLegPillColor( leg ),
                    "color":       palette.overlayTextSecondary,
                }}
            >
                {normalizeStopLabel( leg.to?.name ) ?? "Arrivée"}
                {hasNonEmptyText( leg.to?.platform ) ? ` (Quai ${ leg.to.platform })` : ""}
            </span>

        </>
    );
};


const ItineraryDetailsLegEnd: React.FC<ItineraryDetailsLegEndProps> = ( { leg, nextLeg, isDarkUi } ) => {
    const isTransitLeg = isTransitLegMode( leg.mode );
    const palette = getUIColorPalette( isDarkUi );
    const shouldShowTransitionLine = isTransitLeg && nextLeg != null && !isTransitLegMode( nextLeg.mode );

    if ( !shouldShowTransitionLine ) {
        return (
            <div
                className={WRAPPER_CLASS_NAME}
                id={`itinerary-details-leg-${ leg.id }-end`}
            >
                <div className={CONNECTOR_PADDING_CLASS_NAME} />
            </div>
        );
    }

    const arrivalTimeMs = leg.to?.time != null ? new Date( leg.to.time ).getTime() : null;

    return (
        <div
            className={WRAPPER_CLASS_NAME}
            id={`itinerary-details-leg-${ leg.id }-end`}
        >
            <div className="flex w-full">
                <div className={`flex items-stretch justify-center ${ CONNECTOR_PADDING_CLASS_NAME }`}>
                    <span
                        className="block w-[3px] self-stretch"
                        style={{ "backgroundColor": getItineraryLegColorHex( leg ) }}
                    />
                </div>
                <ArrivalBadge
                    isDarkUi={isDarkUi}
                    leg={leg}
                />
                <span
                    className="mr-1 ml-auto self-center text-right text-xs font-semibold"
                    style={{ "color": palette.overlayTextSecondary }}
                >
                    {arrivalTimeMs != null && !Number.isNaN( arrivalTimeMs ) ? formatItineraryTime( arrivalTimeMs ) : ""}
                </span>
            </div>
        </div>
    );
};

export default ItineraryDetailsLegEnd;
